export const getCookie = function(name) {
  let arr
  const reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)') // "(^| )" 匹配开头和空格
  if (document.cookie.match(reg)) {
    arr = document.cookie.match(reg)
    return decodeURI(arr[2])
  }
  return ''
}

const t = new Date()
const h = t.getFullYear()
export const setCookie = function(name, value) {
  document.cookie = `${name} = ${encodeURI(value)};expires=Thu, 28 Dec ${h + 1} 12:00:00 GMT; path=/`
}



// WEBPACK FOOTER //
// ./src/utils/cookie.js